import { validateEvent } from '@/services/ActivityLogs';

const EVENT_QUEUE_KEY = 'event_queue';
const BATCH_SIZE = 20; // send max 20 at once

export const getEventQueue = (): any[] => {
  if (typeof window === 'undefined') return [];
  const data = localStorage.getItem(EVENT_QUEUE_KEY);
  return data ? JSON.parse(data) : [];
};

export const validateEventInDev = (event: any, tag = '[Event]') => {
  // Only validate against the API in development / staging — never in production
  if (process.env.NEXT_PUBLIC_APP_ENV !== 'production') {
    return validateEvent({
      platform: 'website',
      payload: event,
    })
      .then((response) => {
        if (response.status === 'pass') {
          console.info(
            `%c${tag} ${event?.event}`,
            'color: #22c55e; font-weight: bold;',
            event,
          );
        } else {
          console.info(
            `%c${tag} ${event?.event}`,
            'color: #f59e0b; font-weight: bold;',
            response.errors,
          );
        }
        return response;
      })
      .catch((error) => {
        console.info(
          `%c${tag} ${event?.event}`,
          'color: #ef4444; font-weight: bold;',
          error?.response?.data,
        );
        return null;
      });
  }
  return Promise.resolve(null);
};

export const addEventToQueue = (event: any) => {
  if (typeof window === 'undefined') return;

  validateEventInDev(event);

  const queue = getEventQueue();
  queue.push({
    ...event,
    _queued_at: Date.now(),
  });

  localStorage.setItem(EVENT_QUEUE_KEY, JSON.stringify(queue));
};

export const addEventsToQueue = (events: any[]) => {
  if (typeof window === 'undefined' || !events?.length) return;
  const queue = getEventQueue();
  const timestampedEvents = events.map((event) => ({
    ...event,
    _queued_at: event._queued_at || Date.now(),
  }));
  queue.push(...timestampedEvents);
  localStorage.setItem(EVENT_QUEUE_KEY, JSON.stringify(queue));
};

export const removeEventsFromQueue = (count: number) => {
  const queue = getEventQueue();
  const updatedQueue = queue.slice(count);
  localStorage.setItem(EVENT_QUEUE_KEY, JSON.stringify(updatedQueue));
};

export const getBatch = (): any[] => {
  const queue = getEventQueue();
  return queue.slice(0, BATCH_SIZE);
};
